import styled from 'styled-components';
import { Overlay } from './Overlay';

export const Shade = styled(Overlay)`
  background-color: var(--background-color);
  opacity: 0.5;
`;
